<template>
  <div>
    <div class="d-flex justify-content-center p-4 bg-secondary">
      <img :src="`img/logo-2.png`" alt="Logo" style="width:350px" />
    </div>
    <b-container fluid>
      <CandidateSearch class="p-2 pt-4" />
    </b-container>
  </div>
</template>

<script>
import CandidateSearch from '@/components/CandidateSearch/CandidateSearch'

export default {
  name: 'HomeView',
  components: {
    CandidateSearch
  }
}
</script>
